import { Navigate } from "react-router-dom";
import { ACCESS_TOKEN } from "../constants";
import useUser from "../providers/user/user_provider";
import NotFound from "../views/not_found/not_found";
import Loading from "../components/loading/loading";
import MainLayout from "../layouts/main/main_layout";

interface PrivateRouteProps {
  element: JSX.Element;
  module?: string;
  path?: string
  // Platform Admin only - not even a tenant's own Super Admin (same rule
  // use_nav_options.tsx already applies to hide these from the sidebar).
  // `module` is reused as a generic "requires elevated access" tag across
  // many unrelated routes (Client Mapping, Settings, Admins, Analytics,
  // File Upload all pass module='reports' too), so this is a separate flag
  // rather than special-casing module here - only the actual /reports and
  // /organizations routes set it.
  platformOnly?: boolean

}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element, module, path, platformOnly, ...rest }) => {
  let { userPermissions, accessToken, loading, sessionReady } = useUser();
  let token = accessToken || sessionStorage.getItem(ACCESS_TOKEN);

  if (!sessionReady || (token && loading && !userPermissions)) {
    return <Loading />;
  }

  if (!token) {
    return <Navigate to="/" />;
  }

  if (platformOnly) {
    return userPermissions?.isPlatformOrg ? element : <NotFound />;
  }

  return userPermissions?.superAdmin ?
    element : module && userPermissions?.permissions.map((permission) => permission.module).includes(module=='surveys'?'choices':module)
      ? element : <NotFound />;
}


export default PrivateRoute;
